import React from 'react';
import { Typography, IconButton, InputAdornment } from '@mui/material';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Controller, useFormContext } from 'react-hook-form';
import {
  SearchFieldStyled,
  StyledClearIcon,
  StyledSearchIcon,
} from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/Library/styles';
import { fields } from '@v2/components/campaign/CampaignAdGroupSection/AdvancedSubflows/AdvancedCreative/constants';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

export const SelectCreativesHeader = ({
  onBack,
  onCancel,
  isDisplay,
}: {
  onBack?: () => void;
  onCancel?: () => void;
  isDisplay: boolean;
}) => {
  const { control, setValue } = useFormContext();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      pt={1}
    >
      <Box display="flex" alignItems="center" gap={2} width="100%">
        <IconButton onClick={onBack} size="large" sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h3" sx={{ whiteSpace: 'nowrap' }}>
          Step 1: Select Creatives
        </Typography>

        <Controller
          control={control}
          name={'search'}
          render={({ field }) => {
            const { value } = field;
            return (
              <SearchFieldStyled
                {...field}
                placeholder={isDisplay ? 'Search displays' : 'Search videos'}
                variant="outlined"
                inputProps={{
                  'data-testid': 'creatives-search-input',
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {value ? (
                        <StyledClearIcon
                          icon={faTimes}
                          onClick={() => {
                            setValue(fields.search.path, '');
                          }}
                        />
                      ) : (
                        <StyledSearchIcon />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            );
          }}
        />
      </Box>

      <IconButton onClick={onCancel} size="large" aria-label="close">
        <CloseIcon data-testid="CloseIcon" />
      </IconButton>
    </Box>
  );
};
